import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Environment } from '@desbank/core/src/lib/environment';
import { StorageService } from '@desbank/core/src/lib/services/storage';


@Injectable({
  providedIn: 'root'
})
export class LoggedService {

  constructor(
    private router: Router,
    private storageService: StorageService,
    @Inject('environment') private env: Environment
  ) {}

  get loggedUser(): any {
    const loggedUser = this.storageService.getSession(this.env.authKey);

    if (!loggedUser) {
      this.router.navigate(['/login']);
    }

    return loggedUser;
  }

  public dispatchExpiredSession(): void {
    this.storageService.cleanAllSessions();
    this.router.navigate(['/login']);
  }
}
